{
  "name": "long-angular",
  "version": "0.3.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build:sentry": "ng build && npm run sentry:sourcemaps",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org ftw-masters --project long-angular ./dist && sentry-cli --url https://sentry.ftwmasters.com.br/ sourcemaps upload --org ftw-masters --project long-angular ./dist"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.0.0",
    "@angular/common": "^20.0.0",
    "@angular/compiler": "^20.0.0",
    "@angular/core": "^20.0.0",
    "@angular/forms": "^20.0.0",
    "@angular/platform-browser": "^20.0.0",
    "@angular/platform-browser-dynamic": "^20.0.0",
    "@angular/router": "^20.0.0",
    "@ckeditor/ckeditor5-angular": "^10.0.0",
    "@ng-select/ng-select": "^15.1.0",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "@sentry/angular": "^9.25.1",
    "@sentry/cli": "^2.50.2",
    "@tailwindcss/forms": "^0.5.10",
    "@types/feather-icons": "^4.29.4",
    "ethers": "^6.13.5",
    "feather-icons": "^4.29.2",
    "lightgallery": "^2.8.2",
    "ng-click-outside2": "^17.0.0",
    "ngx-countup": "^13.2.0",
    "rxjs": "~7.8.2",
    "simplebar": "^6.3.0",
    "simplebar-angular": "^3.3.0",
    "tiny-slider": "^2.9.4",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.0.0",
    "@angular/build": "^20.0.0",
    "@angular/cli": "^20.0.0",
    "@angular/compiler-cli": "^20.0.0",
    "@types/jasmine": "~5.1.0",
    "autoprefixer": "^10.4.20",
    "ckeditor5": "^46.0.0",
    "jasmine-core": "~5.7.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "postcss": "^8.4.49",
    "tailwindcss": "^3.4.17",
    "typescript": "~5.8.2"
  }
}
